import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import './styles.scss';
import {connect} from 'react-redux';
import {RouteComponentProps, useHistory, withRouter} from 'react-router-dom';
import {
  addToGlobalStyles,
  addToWizard,
  setGlobalStyles,
  setWizard,
} from '../../../store/actions';
import {compose} from 'redux';
import {Link} from 'react-router-dom';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import {post} from '../../../api/api';
import {uriPostConsentReceipts} from '../../../api/endpoints';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import colors, {pageBackgrounds} from '../../../util/colors';
import {ITenant} from '../../../App';
import {createGUID} from '../../../util/utility';
export interface BeforeContinueProps extends RouteComponentProps {
  wizard: any;
  user: any;
  purposes: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.login;
  labelsDefault: typeof strings;
  oneTrust: typeof strings.pt.oneTrust;
  setGlobalStyles(value: any): void;
  globalStyles: any;
  digitalCommunications: any;
  tenant: ITenant;
  busFuncMapDefault: any;
}

export interface BeforeContinueState {
  validForm: boolean;
}

const BeforeContinue = (props: any) => {
  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    props.busFuncMapDefault?.[props.functionalitiesAliasMap?.oneTrust],
  );

  const [linkColor] = useState(props.globalStyles.primaryColort);
  const history = useHistory();

  const validationSchema = Yup.object().shape({
    termsAccepted: Yup.boolean()
      .required()
      .oneOf([true], props.labelsDefault.pt?.messages?.requiredField),
    privacyPolicyAccepted: Yup.boolean()
      .required(props.labelsDefault.pt?.messages?.requiredField)
      .oneOf([true], props.labelsDefault.pt?.messages?.requiredField),
  });
  const featureName = 'Login-BeforeContinue';

  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (clicked) {
      try {
        const nif = props.user.nif;
        const token = props.oneTrust.tokenMyAdv;
        const body = JSON.stringify({
          identifier: nif,
          test: true,
          requestInformation: token,
          purposes: props.purposes,
        });
        oneTrustIsVisible &&
          post(uriPostConsentReceipts(), body, false, featureName);
      } catch (e: any) {}
    }
  }, [clicked]);

  useEffect(() => {
    props.addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
  }, []);

  return (
    <Column className="before-continue-container">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-row">
          <Header1
            style={{...fonts.XL, color: colors.black, fontWeight: 'bold'}}
            className="before-you-continue">
            {props.labels?.login_beforeYouContinue}
          </Header1>
          <Header1
            style={{...fonts.L, color: colors.black, fontWeight: 'bold'}}
            className="before-you-continue-responsive">
            {props.labels?.login_beforeYouContinue}
          </Header1>
        </Row>
        <AppForm
          className="communications-form-container"
          initialValues={{
            termsAccepted: false,
            privacyPolicyAccepted: false,
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const purposes = [];
            //Aceitação de Condições de Utilização: 89893fde-b6e2-46ef-a2fe-b30b4feb8226 ,
            //Aceitação dos Termos de Tratamento dos Dados:f591a75d-b7d8-481f-a3ce-7844d44e2eea

            purposes.push({
              Id: props.labelsDefault?.pt?.oneTrust.purposeTermsAndConditions,
            });
            purposes.push({
              Id: props.labelsDefault?.pt?.oneTrust.purposePolicyDataTreatment,
            });

            const body = JSON.stringify({
              identifier: props.user.nif,
              test: true,
              requestInformation: props.labelsDefault?.pt?.oneTrust.tokenMyAdv,
              purposes: purposes,
            });
            post(uriPostConsentReceipts(), body, false, featureName).catch(
              (error: any) =>
                console.log('An error occured on onetrust submission: ', error),
            );

            if (
              (props.digitalCommunications === null ||
                props.digitalCommunications === undefined) &&
              props.tenant.loginFlow.insuranceInYourHands
            ) {
              if (props.user.state === 'CLIENT') {
                history.push('/informacao-seguro');
              } else {
                history.push('/inicio');
              }
            } else {
              history.push('/inicio');
            }
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}>
            <div>
              <div
                style={{...fonts.ML}}
                className="before-continue-description">
                {props.labels?.login_beforeYouContinueDescription}
              </div>
              <div
                style={{...fonts.M}}
                className="before-continue-description-responsive">
                {props.labels?.login_beforeYouContinueDescription}
              </div>
              <div
                style={{
                  textAlign: 'left',
                  marginTop: 30,
                }}>
                <AppFormCheckboxField
                  showErrorMessage
                  purposeId={props.oneTrust.purposeTermsAndConditions}
                  style={{justifyContent: 'left', paddingTop: 30}}
                  errorStyle={{marginLeft: '0px', paddingBottom: 5}}
                  name={'termsAccepted'}
                  label={
                    <span style={{...fonts.SM}}>
                      {props.labels?.login_acceptConditions}
                      <a
                        href={props.labels?.login_acceptConditionsUrl}
                        target="_blank"
                        className="accept-link"
                        style={{
                          ...fonts.SM,
                          ...fonts.SemiBold,
                          color: linkColor,
                        }}>
                        {props.labels?.login_acceptConditionsLink}
                      </a>
                    </span>
                  }
                />
              </div>
              <div
                style={{
                  textAlign: 'left',
                  marginTop: 15,
                }}>
                <AppFormCheckboxField
                  showErrorMessage
                  purposeId={props.oneTrust.purposePolicyDataTreatment}
                  style={{justifyContent: 'left', paddingTop: 30}}
                  errorStyle={{marginLeft: '0px', paddingBottom: 5}}
                  name={'privacyPolicyAccepted'}
                  label={
                    <span style={{...fonts.SM}}>
                      {props.labels?.login_acceptPrivacyPolicy}
                      <a
                        href={props.labels?.login_acceptPrivacyPolicyUrl}
                        target="_blank"
                        className="accept-link"
                        style={{
                          ...fonts.SM,
                          ...fonts.SemiBold,
                          color: linkColor,
                        }}>
                        {props.labels?.login_acceptPrivacyPolicyLink}
                      </a>
                    </span>
                  }
                />
              </div>
            </div>
          </div>
          <Row className="continue-button-wrapper">
            <AppFormSubmitButton
              className="continue-button"
              variant="primary"
              title={props.labels?.dataTreatment_continue}
              onClickFunction={() => setClicked(true)}
            />
          </Row>
        </AppForm>
      </Column>
    </Column>
  );
};

const mapStateToProps = ({
  wizard,
  user,
  purposes,
  strings,
  stringsDefault,
  globalStyles,
  digitalCommunications,
  tenant,
  busFuncMapDefault,
}: any) => ({
  wizard: wizard.value,
  user: user.value,
  purposes: purposes.value,
  labels: strings.value.pt.login,
  labelsDefault: stringsDefault.value,
  oneTrust: strings.value.pt.oneTrust,
  globalStyles: globalStyles.value,
  digitalCommunications: digitalCommunications.value,
  tenant: tenant.value,
  busFuncMapDefault: busFuncMapDefault.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(BeforeContinue)),
);
